import { DocumentNode, gql } from '@apollo/client'

export const DECLARE_ABSENCE: DocumentNode = gql`
    mutation DeclareAbsence($regular_slot_id: Int!, $date: Date!, $daycare_id: Int!, $daycare_comment: String) {
        declareAbsence(
            regular_slot_id: $regular_slot_id
            date: $date
            daycare_id: $daycare_id
            daycare_comment: $daycare_comment
        )
    }
`

export const DECLARE_MULTIPLE_ABSENCE: DocumentNode = gql`
    mutation DeclareMultipleAbsence($daycareId: Int!, $slots: [slotIdAndDateAndChildId!], $daycareComment: String) {
        declareMultipleAbsence(daycareId: $daycareId, slots: $slots, daycareComment: $daycareComment)
    }
`

export const CANCEL_ABSENCE: DocumentNode = gql`
    mutation CancelAbsence($regular_slot_id: Int!, $date: Date!, $daycare_id: Int!) {
        cancelAbsence(regular_slot_id: $regular_slot_id, date: $date, daycare_id: $daycare_id)
    }
`

export const UPDATE_UNIQUE_REGULAR: DocumentNode = gql`
    mutation RegularUniqueUpdate(
        $regular_slot_id: Int!
        $date: Date!
        $start: Time!
        $end: Time!
        $daycare_id: Int!
        $placeId: Int
    ) {
        regularUniqueUpdate(
            regular_slot_id: $regular_slot_id
            date: $date
            start: $start
            end: $end
            daycare_id: $daycare_id
            placeId: $placeId
        )
    }
`

export const UPDATE_MULTIPLE_REGULAR: DocumentNode = gql`
    mutation RegularMultipleUpdate(
        $daycareId: Int!
        $slots: [slotIdAndDateAndChildId!]
        $start: Time!
        $end: Time!
        $placeId: Int
    ) {
        regularMultipleUpdate(daycareId: $daycareId, slots: $slots, start: $start, end: $end, placeId: $placeId)
    }
`

export const REQUEST_UPDATE_REGULAR: DocumentNode = gql`
    mutation RequestRegularUpdate(
        $regular_slot_id: Int!
        $date: Date!
        $start: Time!
        $end: Time!
        $reason: String
        $daycare_id: Int!
    ) {
        requestRegularCancellation(
            regular_slot_id: $regular_slot_id
            date: $date
            start: $start
            end: $end
            reason: $reason
            daycare_id: $daycare_id
        )
    }
`

export const REQUEST_MULTIPLE_ABSENCE_REGULAR: DocumentNode = gql`
    mutation RequestMultipleAbsenceRegular(
        $daycareId: Int!
        $slots: [slotIdAndDateAndChildId!]
        $parentComment: String
    ) {
        requestMultipleAbsenceRegular(daycareId: $daycareId, slots: $slots, parentComment: $parentComment)
    }
`

export const DELETE_REQUEST_UPDATE_REGULAR: DocumentNode = gql`
    mutation DeleteRequestRegularUpdate($request: Int!, $child_id: Int!, $daycare_id: Int!) {
        deleteRegularCancellationRequest(request_id: $request, child_id: $child_id, daycare_id: $daycare_id)
    }
`

export const ACCEPT_CANCELLATION_REQUEST: DocumentNode = gql`
    mutation AcceptRequestRegularUpdate(
        $request: Int!
        $accepted: Boolean!
        $daycare_id: Int!
        $daycare_comment: String
    ) {
        acceptRegularCancellation(
            request_id: $request
            accepted: $accepted
            daycare_id: $daycare_id
            daycare_comment: $daycare_comment
        )
    }
`
